module.exports = __webpack_public_path__ + "static/media/weight.06d2a25f.svg";